import {
  Box,
  Checkbox,
  CircularProgress,
  Container,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
  Tooltip,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { getTransactionResponse } from "../../api/api";
import {
  BRAZIL_CNTRY_CODE,
  CASH_SALE,
  DATA_ENTRY,
  EDIT_TRANSACTION,
  LEASE,
  LOST,
  RETAIL_NOTE,
  SALES_MANAGER_ROLE,
  SALES_PERSON_ROLE, SPANISH_COUNTRIES_CODE,
  TXN_SCOPE,
  TXN_STATUS,
  WON,
} from "../../utilities/constants";
import {
  avgSprdMrgPct,
  displayUSformattedDate,
  formatDate,
} from "../../utilities/utils";
import { isAuthorizedactivity } from "../Utility/isAuthorizedactivity";
import ConnectedSearchFilter from "./connected-search-filter";
import ConnectedSearchTablePagination from "./connected-search-table-pagination";
import ConnectedTransactionSummary from "./connected-transaction-summary";
import {getUserObj, hasRole} from "../../utilities/tp-validations";
function SearchTransaction(props) {
  const history = useHistory();
  const [flags, setFlags] = useState({
    txnRowClick: false,
    selectedTxnId: 0,
  });

  const handleSort = (property) => {
    const { searchObj, setSearchObj } = props;
    const newSortOrder =
      searchObj?.sortBy === property && searchObj?.sortOrder === "asc"
        ? "desc"
        : "asc";
    const updatedSearchObj = {
      ...searchObj,
      sortBy: property,
      sortOrder: newSortOrder,
      pageNo: 1,
    };
    setSearchObj(updatedSearchObj);
    handleSearchTransaction(updatedSearchObj);
  };

  const getUserObj = () => {
    return props.isSimulateMode
        ? props.simulatedUserDetails
        : props.userDetails;
  };

  const setActionOnRole = (txnStatus) => {
    const { authorizedRoles } = props.isSimulateMode
      ? props.simulatedUserDetails
      : props.userDetails;
    return authorizedRoles &&
      Object.values(authorizedRoles).includes(SALES_MANAGER_ROLE) &&
      isAuthorizedactivity(EDIT_TRANSACTION.activityId, authorizedActivities)
      ? TXN_SCOPE.EDIT
      : authorizedRoles &&
        Object.values(authorizedRoles).includes(SALES_PERSON_ROLE) &&
        isAuthorizedactivity(
          EDIT_TRANSACTION.activityId,
          authorizedActivities
        ) &&
        txnStatus === TXN_STATUS.PENDING
      ? TXN_SCOPE.EDIT
      : authorizedRoles &&
        Object.values(authorizedRoles).includes(DATA_ENTRY) &&
        isAuthorizedactivity(
          EDIT_TRANSACTION.activityId,
          authorizedActivities
        ) &&
        txnStatus === TXN_STATUS.PENDING
      ? TXN_SCOPE.EDIT
      : TXN_SCOPE.VIEW;
  };

  const sortBidsByBidType = (bids) => {
    const bidOrder = {
      "JD": 1,
      "C1": 2,
      "C2": 3,
    };
    bids.sort((a, b) => {
      const aOrder = bidOrder[a.bidType] ?? Infinity;
      const bOrder = bidOrder[b.bidType] ?? Infinity;
      return aOrder - bOrder;
    });
  };

  const checkMarketSegmentMismatch = (response, domainDetails) => {
    const { countryCode } = getUserObj();
    const { MARKET_SEGMENT_BR, MARKET_SEGMENT_LAT } = domainDetails;
    const isBrazilMismatch = countryCode === BRAZIL_CNTRY_CODE && !MARKET_SEGMENT_BR.some((segment) => segment.domainValue === response.marketSegment);
    const isSpanishMismatch = SPANISH_COUNTRIES_CODE.includes(countryCode) && !MARKET_SEGMENT_LAT.some((segment) => segment.domainValue === response.marketSegment);
    return (isBrazilMismatch || isSpanishMismatch) ? { ...response, marketSegment: "" } : response;
  };

  const displayTransactionDetails = async (data) => {
    setFlags((prevObj) => ({
      ...prevObj,
      txnRowClick: true,
      selectedTxnId: data.txnId,
    }));

    try {
      const response = await getTransactionResponse(data.txnId);
      if (response?.bids?.length) {
        sortBidsByBidType(response.bids);
      }
      const { txnStatus, saleReason, dealerAccountId, dealerBranch, dealSource, saleType, bids } = response || {};
      const checkedResponse = checkMarketSegmentMismatch(response, props.domainDetails);

      props.setActionType("action", setActionOnRole(txnStatus));
      props.setViewTransaction(checkedResponse);

      if (bids?.length) {
        props.setViewTransactionBids(bids[0]); // First bid after sorting
      }

      props.setTransactionBidDropdownValue("saleReason", saleReason);
      props.setBidsTextValue("saleReason", saleReason);
      props.setTransactionRequestDropdownValue("dealerAccountId", dealerAccountId);
      props.setTransactionRequestDropdownValue("dealerAddress", dealerBranch);
      props.setTransactionRequestDropdownValue("dealSource", dealSource);

      props.setPaymentMethod(
          saleType === "CASH_SALE"
              ? CASH_SALE.title
              : saleType === "LEASE_SALE"
                  ? LEASE.title
                  : RETAIL_NOTE.title
      );

      props.clearAllAttachments();
      const updatedAttachments = data?.attachments?.map((attachment) => ({
        ...attachment,
        fileStatus: "EXISTING",
      }));
      props.uploadAttachments(updatedAttachments);
      props.setTransactionStatus(txnStatus);
      setFlags((prevObj) => ({
        ...prevObj,
        txnRowClick: false,
      }));
      history.push({ pathname: `/transaction/view` });

    } catch (error) {
      console.error("Error fetching transaction details:", error);
      setFlags((prevObj) => ({
        ...prevObj,
        txnRowClick: false,
      }));
    }
  };


  const handleSearchTransaction = async (searchObj) => {
    const updatedSearchObj = {
      ...searchObj,
    };
    const isSalesPerson = hasRole(SALES_PERSON_ROLE, props);
    const isDataEntryUser = hasRole(DATA_ENTRY, props);
    const userDetails = getUserObj(props);
    if (searchObj.fromDate) {
      updatedSearchObj.fromDate = formatDate(searchObj.fromDate);
    }
    if (searchObj.toDate) {
      updatedSearchObj.toDate = formatDate(searchObj.toDate);
    }
    if (searchObj.avgSprdPct) {
      updatedSearchObj.avgSprdPct = avgSprdMrgPct(searchObj.avgSprdPct);
    }
    if(isSalesPerson){
      updatedSearchObj.salePersonID = userDetails.userId;
    }
    if(isDataEntryUser){
      updatedSearchObj.createByUser = userDetails.userId;
    }
    try {
      await props.fetchSearchTransactions(updatedSearchObj);
      props.setTableVisibility(true);
    } catch (error) {
      console.error("handleSearchTransaction ", error);
    }
  };

  const handleBulkDeleteCheckboxChange = (event) => {
    if (event.target.checked) {
      const allTransactionIds =
        props.searchTransactionResponse?.dataStore.transaction.map((txn) => {
          if (
            txn.txnStatus === "Pending" ||
            txn.txnStatus === "PENDING" ||
            txn.txnStatus === "SUBMITTED"
          ) {
            return txn.txnId;
          }
        }) || [];
      props.setSelectedTransactions(allTransactionIds);
    } else {
      props.resetSearchPageComponents("selectedTxns");
    }
  };

  const handleIndividualDeleteCheckboxChange = (txnId) => {
    if (props.selectedTransactions.includes(txnId)) {
      props.setSelectedTransactions(
        props.selectedTransactions.filter((id) => id !== txnId)
      );
    } else {
      props.setSelectedTransactions([...props.selectedTransactions, txnId]);
    }
  };

  const disabledWhenAllConfirmed = () => {
    let count = 0;
        if(hasRole(SALES_MANAGER_ROLE,props)) {
          count = props.searchTransactionResponse?.dataStore.transaction.some(
              (txn) => ["PENDING", "SUBMITTED", "CONFIRMED"].includes(txn.txnStatus)
          );
        }else {
          count = props.searchTransactionResponse?.dataStore.transaction.some(
              (txn) => ["PENDING", "SUBMITTED"].includes(txn.txnStatus)
          );
        }
      props.setSelectedTxnStatus(count <= 0);
  };

  useEffect(() => {
    disabledWhenAllConfirmed();
  }, [props.searchTransactionResponse]);

  const getTableSortLabel = (id, value) => {
    const { searchObj } = props;
    return (
      <TableCell>
        <TableSortLabel
          active={searchObj?.sortOrder === id}
          direction={searchObj?.sortOrder === id ? searchObj?.sortBy : "asc"}
          onClick={() => handleSort(id)}
        >
          {value}
        </TableSortLabel>
      </TableCell>
    );
  };

  const authorizedActivities = props.isSimulateMode
    ? props.simulatedBusinessActivities
    : props.businessActivities;

  return (
    <React.Fragment>
      <Container
        className="container"
        style={{ fontWeight: "bold", marginBottom: "60px", paddingTop: "1rem" }}
      >
        <ConnectedSearchFilter />
        {props.isTableVisible && (
          <div
            style={{ paddingBottom: "0.5rem", display: "block" }}
            className="uxf-main-container"
            id={"connectedTransactionDetails"}
          >
            <Box
              p={5}
              bgcolor={"white"}
              sx={{ borderRadius: "4px", paddingBottom: 4 }}
            >
              <Typography
                variant="h4"
                component="h4"
                style={{ marginBottom: "10px" }}
              >
                <ConnectedTransactionSummary />
              </Typography>
              <Grid item xs>
                <Paper sx={{ width: "100%", overflow: "hidden" }}>
                  <TableContainer sx={{ maxHeight: 440 }}>
                    <Table striped stickyHeader aria-label="sticky table">
                      <TableHead>
                        <TableRow
                          style={{
                            whiteSpace: "nowrap",
                            boxShadow: "rgb(240, 240, 240) 0px 2px",
                          }}
                        >
                          <TableCell>
                            <Checkbox
                              style={{
                                color: props.selectedTxnStatus ? "" : "black",
                              }}
                              disabled={props.selectedTxnStatus}
                              checked={
                                props.selectedTransactions.length ===
                                props.searchTransactionResponse?.dataStore
                                  .transaction.length
                              }
                              indeterminate={
                                props.selectedTransactions.length > 0 &&
                                props.selectedTransactions.length <
                                  props.searchTransactionResponse?.dataStore
                                    .transaction.length
                              }
                              onChange={handleBulkDeleteCheckboxChange}
                            />
                          </TableCell>

                          {getTableSortLabel("txnId", props.texts.TXN_ID)}
                          {getTableSortLabel(
                            "dealerAccountId",
                            props.texts.DLR_ACCT_ID
                          )}
                          {!hasRole(SALES_PERSON_ROLE,props) &&
                            getTableSortLabel(
                              "salesPersonName",
                              props.texts.SALES_PERSON
                            )}
                          {getTableSortLabel(
                            "customerName",
                            props.texts.CUSTOMER_NAME
                          )}
                          {getTableSortLabel(
                            "saleType",
                            props.texts.PAYMENT_METHOD
                          )}
                          {getTableSortLabel("dealResult", props.texts.RESULT)}
                          {getTableSortLabel(
                            "txnDate",
                            props.texts.TRANSACTION_DATE
                          )}
                          {getTableSortLabel(
                            "txnCreatedBy",
                            props.texts.CREATED_BY
                          )}
                          {getTableSortLabel("txnStatus", props.texts.STATUS)}
                          {getTableSortLabel(
                            "dealSource",
                            props.texts.DEAL_SOURCE
                          )}
                          <TableCell>{props.texts.COMMENTS}</TableCell>
                          {getTableSortLabel("dealType", props.texts.DEAL_TYPE)}
                          {getTableSortLabel(
                            "marketSegment",
                            props.texts.MARKET_SEGMENT
                          )}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {props.searchTransactionResponse ? (
                          props.searchTransactionResponse.pageDetails
                            .pageCount > 0 ? (
                            props.searchTransactionResponse.dataStore.transaction.map(
                              (txn) => (
                                <TableRow key={txn.txnId}>
                                  <TableCell>
                                    <Checkbox
                                      style={{
                                        color:
                                          txn.txnStatus === "CONFIRMED" ||
                                          txn.txnStatus === "Confirmed"
                                            ? (hasRole(SALES_MANAGER_ROLE,props) ? "black" :"")
                                            : "black",
                                      }}
                                      checked={
                                        txn.txnStatus === "CONFIRMED" ||
                                        txn.txnStatus === "Confirmed"
                                          ?  (hasRole(SALES_MANAGER_ROLE,props) ?props.selectedTransactions.includes(
                                            txn.txnId
                                            ) : false) : props.selectedTransactions.includes(
                                              txn.txnId
                                            )
                                      }
                                      onChange={() =>
                                        handleIndividualDeleteCheckboxChange(
                                          txn.txnId
                                        )
                                      }
                                    />
                                  </TableCell>
                                  <TableCell>{txn.txnId}</TableCell>
                                  <TableCell>{txn.dealerAccountId}</TableCell>
                                  {!hasRole(SALES_PERSON_ROLE,props) ? (
                                    txn.salesPersonName ? (
                                      <TableCell>
                                        {txn.salesPersonName}
                                      </TableCell>
                                    ) : (
                                      <TableCell></TableCell>
                                    )
                                  ) : (
                                    ""
                                  )}
                                  <TableCell
                                    style={{
                                      textDecoration: "underline",
                                      cursor: "default",
                                      fontWeight: "bold",
                                    }}
                                    onClick={() =>
                                      displayTransactionDetails(txn)
                                    }
                                  >
                                    {txn.customerName}
                                    {flags.txnRowClick &&
                                      flags.selectedTxnId === txn.txnId && (
                                        <CircularProgress
                                          size="small"
                                          style={{
                                            color: "#000",
                                            marginLeft: "7px",
                                          }}
                                        />
                                      )}
                                  </TableCell>
                                  <TableCell>{txn.saleType}</TableCell>
                                  <TableCell>
                                    {txn.dealResult === "W" ? WON : LOST}
                                  </TableCell>
                                  <TableCell>
                                    {displayUSformattedDate(txn.txnDate)}
                                  </TableCell>
                                  <TableCell>{txn.txnCreatedBy}</TableCell>
                                  <TableCell>{txn.txnStatus}</TableCell>
                                  <TableCell>{txn.dealSource}</TableCell>
                                  <Tooltip title={txn.comments}>
                                    <TableCell
                                      size={"small"}
                                      style={{
                                        maxWidth: "100px",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        whiteSpace: "nowrap",
                                      }}
                                    >
                                      {txn.comments || "NA"}
                                    </TableCell>
                                  </Tooltip>
                                  <TableCell>{txn.dealType}</TableCell>
                                  <TableCell>{txn.marketSegment}</TableCell>
                                </TableRow>
                              )
                            )
                          ) : (
                            <TableRow>
                              <TableCell colSpan={13} align="center">
                                {props.texts.NODATA_FOUND_MSG}
                              </TableCell>
                            </TableRow>
                          )
                        ) : (
                          <TableRow>
                            <TableCell colSpan={13} align="center">
                              <Box
                                alignItems="center"
                                display="flex"
                                flexDirection="column"
                                justifyContent="center"
                                px={10}
                                py={30}
                              >
                                <CircularProgress size="lg" />
                                <Typography
                                  style={{
                                    marginTop: "1.5rem",
                                    marginBottom: "0.5rem",
                                  }}
                                  variant="h1"
                                >
                                  {props.texts.RETRIEVE_TRAN_DET_MSG}
                                </Typography>
                                <Typography variant="body2">
                                  {props.texts.EXPORT_TRAN_WAITING_MSG}
                                </Typography>
                              </Box>
                            </TableCell>
                          </TableRow>
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>
                  <ConnectedSearchTablePagination />
                </Paper>
              </Grid>
            </Box>
          </div>
        )}
      </Container>
    </React.Fragment>
  );
}

export default SearchTransaction;
